module.exports = __webpack_public_path__ + "static/media/hall-masthead-mobile.d00237eb.png";